import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Badge from '@material-ui/core/Badge';
import { styled } from '@material-ui/core/styles';
import primaryModerator from 'src/Assets/images/headers/primarymoderator.svg';
import moderator from 'src/Assets/images/headers/moderator.svg';

const defaultStyle = {
  borderRadius: '50%',
  width: '45px',
  height: '45px'
};


const BottomRightBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    bottom: -10,
    right: 7,
    top: "auto",
    left: "auto",
    padding: 0,
    background: "transparent",
    position: "absolute",
  },
}));


const SmallAvatar = styled(Avatar)(({ theme }) => ({
  width: 22,
  height: 22,
  border: `2px solid ${theme.palette.background.paper}`,
}));

const AvatarBadge = ({ src, alt, isPrimaryModerator, isModerator, isChild, size, className, style }) => {
  const crown = isPrimaryModerator
    ? primaryModerator
    : isModerator
      ? moderator
      : "";

  const avatarStyle = size
    ? { ...defaultStyle, width: size, height: size, ...style }
    : { ...defaultStyle, ...style };

  const badgeSize = size ? Math.max(16, Math.min(22, Math.round(size * 0.48))) : 22;

  return (
    <>
      {isChild ? (
        <BottomRightBadge
          className={className}
          badgeContent={
            crown
              ? <SmallAvatar alt="crown" src={crown} style={{ width: badgeSize, height: badgeSize }} />
              : null
          }>
          <Avatar
            src={src}
            style={avatarStyle}
            variant="square"
            alt={alt || "Avatar"}
          />
        </BottomRightBadge>
      ) : (
        <Badge
          className={className}
          overlap="circular"
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          badgeContent={
            crown
              ? <SmallAvatar alt="crown" src={crown} style={{ width: badgeSize, height: badgeSize }} />
              : null
          }
        >
          <Avatar
            src={src}
            style={avatarStyle}
            variant="square"
            alt={alt || "Avatar"}
          />
        </Badge>
      )}
    </>
  )
};

export default AvatarBadge;
